module.exports = __webpack_public_path__ + "img/is1.8630d02e.svg";